import { useContext } from 'react';
import { DataContext, type DataContextType } from '../../context/DataContext';

export const useSidebarData = (): DataContextType => {
  return useContext(DataContext) as DataContextType;
};
